import { render, staticRenderFns } from "./ArrayedEdit.vue?vue&type=template&id=3535dcdb&scoped=true&"
import script from "./ArrayedEdit.vue?vue&type=script&lang=js&"
export * from "./ArrayedEdit.vue?vue&type=script&lang=js&"
import style0 from "./ArrayedEdit.vue?vue&type=style&index=0&id=3535dcdb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3535dcdb",
  null
  
)

export default component.exports